// extracted by mini-css-extract-plugin
export default {"privacy_card":"Privacy_privacy_card__pbudK"};